import Vue from 'vue';

export default {
  SET_CALL_LIST_ID(state, callListId) {
    state.callListId = callListId;
  },
  SET_CONFERENCE_ID(state, conferenceId) {
    state.conferenceId = conferenceId;
  },
  SET_SOFT_PHONE(state, softPhone) {
    state.softPhone = softPhone;
  },
  SET_KEEP_CALLING(state, keepCalling) {
    state.keepCalling = keepCalling;
  },
  SET_CALL(state, call) {
    state.call = call;
  },
  SET_NOTIFICATION(state, notification) {
    state.notification = notification;
  },
  SET_CALL_CENTER_STATUS(state, status) {
    state.callCenterStatus = status;
  },
  SET_CALL_TYPE(state, callType) {
    if (!callType) {
      localStorage.removeItem('call_type');
    } else {
      localStorage.setItem('call_type', callType);
    }
    state.callType = callType;
  },
  SET_EXTENSION(state, extension) {
    state.extension = extension;
  },
  SET_EXTENSIONS(state, extensions) {
    state.extensions = extensions;
  },
  SET_EXTENSION_NUMBER(state, extension) {
    state.extensionNumber = extension;
  },
  ADD_CALL_TO_SAVE(state, callToSave) {
    const searchById = callToSave.type_id === 6;
    const index = state.callsToSave.findIndex(item => item[searchById ? 'id' : 'call_id'] === callToSave[searchById ? 'id' : 'call_id']);
    if (index === -1) {
      state.callsToSave.unshift(callToSave);
    } else {
      Vue.set(state.callsToSave, index, callToSave);
    }
    localStorage.setItem('calls_to_save', JSON.stringify(state.callsToSave));
  },
  REMOVE_CALL_TO_SAVE(state, callId) {
    const index = state.callsToSave.findIndex((item) => {
      const searchById = item.type_id === 6;
      return item[searchById ? 'id' : 'call_id'] === callId;
    });
    if (index !== -1) {
      state.callsToSave.splice(index, 1);
      localStorage.setItem('calls_to_save', JSON.stringify(state.callsToSave));
    }
  },
  SET_LAST_PING_EXTENSION(state, lastPingExtension) {
    state.lastPingExtension = lastPingExtension;
  },
  SET_DISCONNECT_REASON(state, disconnectReason) {
    state.disconnectReason = disconnectReason;
  },
  SET_IS_RECORDING(state, isRecording) {
    localStorage.setItem('is_recording', isRecording);
    state.isRecording = isRecording;
  },
  SET_CURRENT_RECORDING(state, currentRecording) {
    localStorage.setItem('current_recording', JSON.stringify(currentRecording));
    state.currentRecording = currentRecording;
  },
  SET_MAX_COMMITMENT_DAYS(state, maxCommitmentDays) {
    localStorage.setItem('max_commitment_days', maxCommitmentDays);
    state.maxCommitmentDays = maxCommitmentDays;
  },
  SET_RECONNECTING(state, reconnecting) {
    state.reconnecting = reconnecting;
  },
  START_CALL_RECORDING(state, callId) {
    state.callRecordingId = callId;
    state.callRecordingState = true;
  },
  STOP_CALL_RECORDING(state) {
    state.callRecordingId = '';
    state.callRecordingState = false;
  },
  SET_CALL_RECORDING(state, recording) {
    state.callRecordingId = recording.call_recording || '';
    state.callRecordingState = recording.keep_recording || false;
  },
  SET_MANUAL_CALL_LOADING(state, payload) {
    state.isManualCallLoading = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/dialer/moduleDialerMutations.js